// extracted by mini-css-extract-plugin
module.exports = {"pinkCard":"ProjectCard_pinkCard__21-Ow","blueCard":"ProjectCard_blueCard__JZL2K","signUpArrow":"ProjectCard_signUpArrow__1Sby2"};